// extracted by mini-css-extract-plugin
export default {"brandItem":"src-feature-ui-brand-__brand_brandItem"};